import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@aiia/portal-core';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { LogoIcon } from '../../components/Logo';

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'en';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/">
              <LogoIcon size={108} />
            </Link>
            <div className="flex items-center gap-3">
              <LanguageSwitcher />
              <Link
                to={isAuthenticated ? `/${lang}/dashboard` : '/'}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                {isAuthenticated ? t('public.portal') : t('public.home')}
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center text-sm space-y-2">
          <p>&copy; {new Date().getFullYear()} AIIA. {t('public.allRightsReserved')}</p>
          <p>
            {t('public.support')}:{' '}
            <a href="mailto:support@ai-ia.dev" className="text-blue-400 hover:text-blue-300 transition-colors">
              support@ai-ia.dev
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
